import { render, staticRenderFns } from "./SyncPlatProduct.vue?vue&type=template&id=68e72dde&scoped=true&"
import script from "./SyncPlatProduct.vue?vue&type=script&lang=js&"
export * from "./SyncPlatProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e72dde",
  null
  
)

export default component.exports